var _path, _circle, _rect, _circle2, _circle3, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjOnSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 55.5L57.5 57.5M56 53H59M53 56V59",
    stroke: "#103B5D",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.5,
    width: 44,
    height: 44,
    stroke: "#103B5D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 17.5,
    fill: "#103B5D",
    stroke: "#103B5D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 2.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7071,
    y: 31.9497,
    width: 6,
    height: 9,
    rx: 3,
    transform: "rotate(-45 27.7071 31.9497)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.5L17.5 17.5",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L27.5 27.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.5C47.5 26.5 53.5 32.5 53.5 40",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 40C26.5 47.5 32.5 53.5 40 53.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 40C30.5 45 34.5 49.5 40 49.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.5C45.5 30.5 49.5 35 49.5 40",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjOnSite);
export default __webpack_public_path__ + "static/media/DJ_on_Site.47afb9a118d985e987cdcce905ae32ae.svg";
export { ForwardRef as ReactComponent };